import { useRef } from 'react';

/* An accessible tab strip (WAI-ARIA tabs pattern): arrow keys / Home / End move between tabs, only the selected tab is in the tab order.
 * `tabs` is [[id, label], ...]; `children` is the content of the selected tab. */
export default function Tabs({ idPrefix, label, tabs, value, onChange, children }) {
  const refs = useRef({});
  const move = (e, i) => {
    const next = e.key === 'ArrowRight' ? (i + 1) % tabs.length : e.key === 'ArrowLeft' ? (i + tabs.length - 1) % tabs.length
      : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : null;
    if (next === null) return;
    e.preventDefault();
    const id = tabs[next][0];
    onChange(id);
    refs.current[id]?.focus();
  };
  return (
    <div className="tabs">
      <div className="ui top attached tabular menu" role="tablist" aria-label={label}>
        {tabs.map(([id, text], i) => (
          <button key={id} type="button" role="tab" ref={(el) => { refs.current[id] = el; }} id={`${idPrefix}-tab-${id}`} aria-controls={`${idPrefix}-panel-${id}`}
            aria-selected={value === id} tabIndex={value === id ? 0 : -1} className={`item${value === id ? ' active' : ''}`}
            onClick={() => onChange(id)} onKeyDown={(e) => move(e, i)}>{text}</button>
        ))}
      </div>
      <div className="ui bottom attached segment tabpanel" role="tabpanel" id={`${idPrefix}-panel-${value}`} aria-labelledby={`${idPrefix}-tab-${value}`} tabIndex={-1}>
        {children}
      </div>
    </div>
  );
}
